import axios from "axios";

import {
  authDeviceWithDomainHeader,
  authWithDomainHeader,
} from "../authServices/auth.header";
import { setCallFlow } from "@/helpers/BatchService.js";

const API_URL = process.env.VUE_APP_ROOT_API;
class CallFlowService {
  // Get Voice Mail List
  async getCallFlowList(filter = "", domain_uuid = null) {
    return await axios
      .get(API_URL + `call-app/call-flow` + filter, {
        headers: domain_uuid
          ? authWithDomainHeader(domain_uuid)
          : authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  async getCallFlowListByColume(filter) {
    return await axios
      .get(API_URL + `call-app/call-flow` + filter, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Add Call Flow
  async AddCallFlowItem(data) {
    return await axios
      .post(API_URL + `call-app/call-flow`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setCallFlow();
        return response.data;
      });
  }

  // Get Call Flow Item
  async getCallFlowItem(call_flow_uuid) {
    return await axios
      .get(API_URL + `call-app/call-flow/${call_flow_uuid}`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Edit Call Flow Item
  async updateCallFlowItem(call_flow_uuid, data) {
    return await axios
      .put(API_URL + `call-app/call-flow/${call_flow_uuid}`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setCallFlow();
        return response.data;
      });
  }
  // Edit Call Flow Item
  async updateCallFlowItemStatus(call_flow_uuid, data) {
    return await axios
      .patch(API_URL + `call-app/call-flow/${call_flow_uuid}`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //delete Call Flow Item
  async deleteCallFlowItem(call_flow_uuid) {
    return await axios
      .delete(API_URL + `call-app/call-flow/${call_flow_uuid}`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setCallFlow();
        return response.data;
      });
  }
}

export default new CallFlowService();
